import React from 'react'
import localization from '../../localization'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import withLocalization from '@web/helpers/localizationUtils'

const NoData = ({ text, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  return (
    <div style={styles.noDataContainer}>
      {text ? `${t('noRecorded')} ${t(text)}` : t('noDataAvailable')}
    </div>
  )
}

export default withLocalization(NoData, localization)
